import clsx from 'clsx'
import { useState } from 'react'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'

import PanelPerilakuKerja from './PanelPerilakuKerja'

import type { HTMLAttributes } from 'react'

interface AdjustmentInfoPerilakuKerjaProps
  extends HTMLAttributes<HTMLDivElement> {
  text?: string
  title?: string
  originalIndikatorPerilaku?: string
  indikatorPerilaku?: string
  originalPerwujudanPerilaku?: string
  perwujudanPerilaku?: string

  originalLabel?: string
  reviewLabel?: string
}

export default function AdjustmentInfoPerilakuKerja({
  text = 'Ada penyesuaian',
  title = '',
  originalIndikatorPerilaku = '',
  indikatorPerilaku = '',
  originalPerwujudanPerilaku = '',
  perwujudanPerilaku = '',
  className,

  originalLabel = 'Perencanaan Guru',
  reviewLabel = 'Penyesuaian dari Kepala Sekolah',
  ...otherProps
}: AdjustmentInfoPerilakuKerjaProps) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <div
        {...otherProps}
        className={clsx(
          'inline-flex px-4 py-3 justify-center items-center rounded bg-[#ECFEF2] border border-green-50 gap-1 tracking-[0.5px] w-[416px]',
          className
        )}
      >
        <Icon className="!text-green-50 !text-[20px] !w-5 !h-5">check</Icon>

        <Text variant="subheading" className="uppercase flex-1">
          {text}
        </Text>

        <Button
          size="sm"
          color="white"
          className="!bg-transparent"
          onClick={() => setIsOpen(true)}
        >
          Cek
        </Button>
      </div>

      <Dialog size="lg" isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <DialogOverlay />
        <DialogContent>
          <div className="w-full px-12 py-9 flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <Text color="primary" variant="heading-md">
                {originalLabel}
              </Text>
              <PanelPerilakuKerja
                className="w-full"
                title={title}
                indikatorPerilaku={originalIndikatorPerilaku}
                perwujudanPerilaku={originalPerwujudanPerilaku}
              />
            </div>

            <div className="flex justify-center">
              <Icon>arrow_downward</Icon>
            </div>

            <div className="flex flex-col gap-2">
              <Text color="primary" variant="heading-md">
                {reviewLabel}
              </Text>
              <PanelPerilakuKerja
                className="w-full"
                title={title}
                indikatorPerilaku={indikatorPerilaku}
                perwujudanPerilaku={perwujudanPerilaku}
              />
            </div>

            <div className="flex justify-center">
              <Button className="!w-auto" onClick={() => setIsOpen(false)}>
                Saya mengerti
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
